module.exports = __webpack_public_path__ + "img/canvasMenu7.92c7fd66.svg";